export const SMALL_ICON_SIZE = { width: "16px", height: "16px" }
